import type { Action } from 'redux'
import type { StateDefault } from '../../../../../redux/global-store'
import * as types from '../types/change-password-types'

const initialState: StateDefault = {
  success: false,
  load: false,
  error: '',
}

export const changePasswordReducer = (
  state = initialState,
  action: Action & { payload?: any },
) => {
  const newState = { ...state }

  switch (action.type) {
    case types.CHANGE_PASSWORD_REQUEST:
      newState.load = true
      return newState

    case types.CHANGE_PASSWORD_ERROR:
      newState.load = false
      newState.error = action.payload
      return newState

    case types.CHANGE_PASSWORD_SUCCESS:
      newState.load = false
      newState.success = action.payload
      return newState

    case types.CHANGE_PASSWORD_RESET:
      return initialState

    default:
      return { ...state }
  }
}
